import type { BootstrapData } from '../../types'
import { BOOTSTRAP_DATA, PLATFORM_LOGGER, SERVICE_CONFIG_PROVIDER, SERVICE_DEF_CONFIG, SERVICES_LOADER } from './moduleNames'
import { createServicesManager, createServicesMap } from '@wix/services-manager'
import type { ServicesManager } from '@wix/services-manager/types'
import type { IPlatformLogger } from '@wix/thunderbolt-symbols'

export interface IServices {
	getService: ServicesManager['getService']
}

const ServicesLoader = (
	bootstrapData: BootstrapData,
	logger: IPlatformLogger,
	serviceConfigProvider: {
		[serviceDefinition: string]: any
	},
	serviceDefinitionToFactory: any
): IServices => {
	const { serviceDefinitionToConfig } = bootstrapData

	const serviceManager = createServicesManager(
		createServicesMap(
			Object.entries(serviceDefinitionToConfig!).map(([definition, config]) => ({
				definition,
				config: serviceConfigProvider[definition] || config,
				impl: serviceDefinitionToFactory[definition].impl,
			}))
		)
	)
	return {
		getService: (serviceDefinition) => {
			if (!serviceManager) {
				const error = new Error('Service manager is not initialized')
				logger.captureError(error, {
					tags: {
						feature: 'platform',
					},
				})
				throw error
			}
			return serviceManager.getService(serviceDefinition)
		},
	}
}

export default {
	factory: ServicesLoader,
	deps: [BOOTSTRAP_DATA, PLATFORM_LOGGER, SERVICE_CONFIG_PROVIDER, SERVICE_DEF_CONFIG],
	name: SERVICES_LOADER,
}
